import { compose } from 'redux';
import Detail from './Detail';
import { query } from '../API';
import withRequestTracker from '../../../../utils/composition/withRequestTracker';

const composedProductiveCoverageDetail = compose(withRequestTracker({ query }))(Detail);

export default composedProductiveCoverageDetail;
